export const asArray = <T>(v: T[] | T | null | undefined): T[] =>
  Array.isArray(v) ? v : [];
